export const LOAD_DS_DICTIONARIES = 'LOAD_DS_DICTIONARIES';
export const CLEAR_DS_DICTIONARIES = 'CLEAR_DS_DICTIONARIES';
